import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';

export default function AuthGuard({ children }) {
  const { isLoggedIn, logout, selectedVenueData, venueDataLoading, user } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 1) Not logged in → just go to login
    if (!isLoggedIn) {
      // avoid double redirect: let logout clear state, but don't redirect inside it
      logout(false);
      navigate('/auth/login', { replace: true });
      return;
    }

    // 2) Still fetching venue data after a page refresh — wait before deciding
    if (venueDataLoading) return;

    // 3) Logged in, but no venue data
    if (!selectedVenueData) {
      // Only block venue routes if no venue is selected
      const isVenueRoute = location.pathname.startsWith('/dashboard/venue/');
      if (isVenueRoute) {
        navigate('/dashboard/settings', { replace: true });
      }
      return;
    }

    // 4) Have venue data & it's NOTACTIVE → force them to that venue dashboard (superadmins bypass)
    const isSuperAdmin = user?.isSuperAdmin === 1 || user?.isSuperAdmin === true || user?.isSuperAdmin === '1' || user?.isSuperAdmin === 'true' || user?.isSuperAdmin === 'True';
    if (
      !isSuperAdmin &&
      selectedVenueData.isActiveString === 'NOTACTIVE' &&
      location.pathname !== `/dashboard/venue/${selectedVenueData.orgID}`
    ) {
      navigate(`/dashboard/venue/${selectedVenueData.orgID}`, { replace: true });
    }
  }, [
    isLoggedIn,
    selectedVenueData,
    venueDataLoading,
    logout,
    navigate,
    location.pathname
  ]);

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };